module.exports = __webpack_public_path__ + "static/media/duo_guru_desc1.54365915.jpeg";